import App from './App.svelte';

const target = document.getElementById('app')
const app = new App({ target });

export default app;